import { Component, Inject } from '@angular/core';
import {
    MAT_DIALOG_DATA,
    MatDialogRef,
} from '@angular/material/dialog';
import { ContractFileGroup } from '../../../contracte-programari.interface';

@Component({
    selector: 'app-view-document',
    templateUrl: './view-document.component.html',
    styleUrls: ['./view-document.component.scss'],
})
export class ViewDocumentComponent {
    group!: ContractFileGroup;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            group: ContractFileGroup;
        },
        private dialogRef: MatDialogRef<ViewDocumentComponent>,
    ) {
        this.group = this.data.group;
    }

    closeDialog(): void {
        this.dialogRef?.close({ success: false });
    }
}